import React from 'react';
import Portal from 'react-portal';
import Carousel from '../Carousel';
import './styles.scss';

const KEY_CODES = {
  LEFT: 37,
  RIGHT: 39,
};

/* eslint-disable no-invalid-this */
export default class Lightbox extends React.Component {
  previous = () => this.refs.carousel.previous();

  next = () => this.refs.carousel.next();

  handlekeypress = (e) => {
    if (!this.isOpen()) {
      return;
    }

    switch (e.keyCode) {
      case KEY_CODES.LEFT:
        this.previous();
        break;
      case KEY_CODES.RIGHT:
        this.next();
        break;
      default:
        break;
    }
  };
  componentDidUpdate(prevProps) {
    // console.log(prevProps)
    const body = document.querySelector('body');
    // console.log(this.modal);
    if (!prevProps.startSlide >= 0 && this.isOpen()) {
      // grab the last active el to go back to when close
      this.focusedElBeforeOpen = document.activeElement;

      // focus the first interactive element within when open
      const focusableEls = this.modal.node.querySelectorAll(
        'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]'
      );
      this.focusableEls = Array.prototype.slice.call(focusableEls);
      this.firstFocusableEl = this.focusableEls[0];
      this.firstFocusableEl.focus();
      // for tabbing/shift+tabbing
      document.addEventListener('keydown', this.handleKeyDown);
      this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];
    }
    if (prevProps.startSlide >= 0 && !this.props.modalOpen) {
      // return to the last active el when close
      this.focusedElBeforeOpen.focus();

      // for tabbing/shift+tabbing
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }
  // Change keypress to keypress for ADA
  componentDidMount() {
    typeof document !== 'undefined' &&
      document.addEventListener('keypress', this.handlekeypress, false); //eslint-disable-line no-undef
  }

  componentWillUnmount() {
    typeof document !== 'undefined' &&
      document.removeEventListener('keypress', this.handlekeypress); //eslint-disable-line no-undef
  }

  isOpen() {
    return this.props.startSlide >= 0;
  }

  render() {
    // Lightbox = modal + image carousel (+ keyboard nav),
    // so this composition basically makes sense.
    return (
      <Portal
        isOpened={this.isOpen()}
        closeOnEsc
        closeOnOutsideClick
        ref={(e) => (this.modal = e)}
        onClose={this.props.onClose}
      >
        <div
          tabindex={0}
          className="lightbox"
          aria-label="slideshow. Use left and right arrow keys to navigate"
        >
          <Carousel
            ref="carousel"
            slides={this.props.slides}
            startSlide={this.props.startSlide}
          />
          <button
            aria-label="Close"
            tabIndex="0"
            className="icon-close"
            onClick={this.props.onClose}
            onKeyPress={this.props.onClose}
          ></button>
        </div>
      </Portal>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/Lightbox/index.js